<template>
    <div class="g cart-list-content">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data: function(){
            
            return {}
        },
    }
</script>

<style scoped lang="scss">

    .g.cart-list-content {
        display: flex;

        @include media('center') {
            display: block;
        }
    }
</style>
